import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const fieldLabelWrapper: ThemeUICSSObject = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexShrink: 0,

  '.fieldLabelWrapper__buttons': {
    display: 'flex',
    gap: spacing(2),
  },

  '& > label': {},
  /* PREPEND HERE */
};

export default fieldLabelWrapper;
